import { useEffect, useRef, useCallback } from 'react';
import { debounce } from 'lodash';

type UsePostListVisibilityProps = {
  isLoading: boolean;
  isFirstRender: React.RefObject<boolean>;
  proGalleryRef: React.RefObject<HTMLDivElement>;
};

const DEBOUNCE_TIME = 1000;

export const usePostListVisibility = ({
  isLoading: isPostListLoading,
  proGalleryRef,
  isFirstRender,
}: UsePostListVisibilityProps) => {
  const isVisible = useRef(false);

  const callback = useCallback((entries: IntersectionObserverEntry[]) => {
    const [entry] = entries;
    isVisible.current = entry.intersectionRatio === 1;
  }, []);

  useEffect(() => {
    if (!proGalleryRef.current) {
      return;
    }

    const observer = new IntersectionObserver(debounce(callback, DEBOUNCE_TIME), { threshold: 1 });
    observer.observe(proGalleryRef.current);
    return () => observer.disconnect();
  }, [callback, proGalleryRef]);

  const shouldScrollPostListToTop =
    !isVisible.current && !isFirstRender.current && !isPostListLoading;

  return shouldScrollPostListToTop;
};
